import React, { useState } from 'react'
import validator from 'validator'
import mainData from '../../FetchDataLinks';
import UseFetchPost from '../../UseFetchPost';

function CommentSubmitForm({ idArticle, cateogary, PostHead, hashtag, slug }) {

    let email;
    let message;
    let CommentorName;

    const [value, setValue] = useState();
    const [commentMSG, setCommentMSG] = useState();

    function handleClick() {
        console.log('Function')
        if (validator.isEmail(email) && message !== undefined) {
            UseFetchPost(mainData.commentPost, `{"email": "${email}", "message": "${message}", "name": "${CommentorName}", "BlogHeadlineID": "${idArticle}", "BlogHeadline": "${PostHead}", "slug": "${slug}", "cateogary": "${cateogary}", "hashtag": "${String(hashtag)}"}`)
            document.getElementById('commentForm').style.display = 'none'
            setValue('Thank you for Your Valueable Comment on my Article.')
            setCommentMSG('You can Refresh the page if you want to see your comment.')
        }
    }


    return (
        <div className="leave-comment-form" id="comment">
            <h3 className="aside-title">Leave a reply</h3>
            {value && <h4 style={{ padding: `2em` }}>{value}</h4>}
            {commentMSG && <h4 style={{ padding: `2em` }}>{commentMSG}</h4>}
            {commentMSG && <button onClick={() => { window.location = document.location }} className="btn btn-style btn-primary">
                Refresh
            </button>}
            <div id='commentForm'>
                <div className="input-grids">
                    <div className="form-group">
                        <input type="text" name="Name" onChange={(e) => { CommentorName = e.target.value }} className="form-control" placeholder="Your Name" required />
                    </div>
                    <div className="form-group">
                        <input type="email" name="Email" onChange={(e) => { email = e.target.value }} className="form-control" placeholder="Email" required />
                    </div>
                    <div className="form-group">
                        <textarea name="Comment" onChange={(e) => { message = e.target.value }} className="form-control" placeholder="Your Comment" required defaultValue={""} />
                    </div>
                </div>
                <div className="submit text-right">
                    <button className="btn btn-style btn-primary" onClick={() => { handleClick() }}>Post Comment </button></div>
            </div>
        </div>
    )
}

export default CommentSubmitForm
